<template>
  <div v-if="images && images.length">
    <div
      class="full-picture"
      @mouseenter="removeSlideHandle"
      @mouseleave="createSlideHandle"
    >
      <i
        v-if="images.length > 1"
        class="fa fa-chevron-left"
        style="left: 10px"
        @click="showPrevSlide"
      ></i>
      <i
        v-if="images.length > 1"
        class="fa fa-chevron-right"
        style="right: 10px"
        @click="showNextSlide"
      ></i>
      <transition-group name="fade">
        <div
          v-for="(slide, idx) in slides"
          :key="'full-picture-' + idx"
          :class="{ active: idx === currentSlideId }"
          class="slide"
        >
          <ImageView :file="slide" :width="360" :height="440"></ImageView>
          <div
            v-if="slide.title && slide.description"
            v-html="slide.description"
            class="description"
          ></div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import ImageView from '../../_shared/components/ImageView.vue';

function shuffle(o) {
  for (
    let j, x, i = o.length;
    i;
    j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x
  );
  return o;
}

export default {
  components: { ImageView },
  props: {
    images: { type: Array },
  },
  data() {
    return {
      currentSlideId: 0,
      currentSlideHandle: void 0,
    };
  },
  computed: {
    slides() {
      if (this.images.length) {
        return shuffle(this.images);
      }

      return [];
    },
  },
  methods: {
    showNextSlide() {
      this.currentSlideId = (this.currentSlideId + 1) % this.slides.length;
    },
    showPrevSlide() {
      this.currentSlideId =
        (this.currentSlideId - 1 + this.slides.length) % this.slides.length;
    },
    createSlideHandle() {
      this.currentSlideHandle =
        this.currentSlideHandle || setInterval(this.showNextSlide, 5000);
    },
    removeSlideHandle() {
      clearInterval(this.currentSlideHandle);
      this.currentSlideHandle = void 0;
    },
  },
  mounted() {
    this.createSlideHandle();
  },
  beforeDestroy() {
    this.removeSlideHandle();
  },
};
</script>

<style lang="scss" scoped>
.full-picture {
  background-color: color-mix(in srgb, var(--color-gray-0) 60%, transparent);
  display: block;
  height: 440px;
  margin-top: 0;
  position: relative;

  i {
    color: var(--text-color);
    cursor: pointer;
    display: none;
    font-size: 60px;
    opacity: 0.6;
    position: absolute;
    text-shadow: 0 0 6px #333333;
    top: 200px;
    z-index: 10;
  }

  &:hover i {
    display: block;
  }

  > span {
    display: block;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}

.slide {
  display: flex;
  height: 100%;
  left: 0;
  max-height: 440px;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 360px;

  &.active {
    opacity: 1;
  }

  img {
    align-self: center;
  }

  .description {
    background-color: var(--background-color-content);
    bottom: 0;
    padding: 6px 10px;
    position: absolute;
    text-align: center;
    width: 100%;
    z-index: 5;
  }
}
</style>
